<template>
  <div id="contenedor-main-listado-contrato-escalatorias">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop
        :listado="listado"
        :solo-lectura="soloLectura">
      </desktop>
    </template>
    <template v-else>
      <desktop
        :listado="listado"
        :solo-lectura="soloLectura">
      </desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoContratoEscalatorias',
  components: {
    Desktop,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
